import ArticleForm from "../../components/common/article-form/ArticleForm";

export default function Article() {
	return <ArticleForm type="articles" />;
}
